import { useState, useEffect } from 'react';
import api from '../API.js';

/**
 * AgentSelector Component
 * Reusable component for selecting RAG agents
 */
function AgentSelector({ selectedAgentId, onAgentChange, className = '' }) {
    const [agents, setAgents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchAgents();
    }, []);

    const fetchAgents = async () => {
        try {
            setLoading(true);
            setError('');
            const response = await api.get('agent', {query: {activeOnly: true}});
            if (response.status !== 200) {
                throw new Error(`Failed to fetch agents: ${response.status}`);
            }
            const agentList = response.data.data || response.data; // Handle both response formats
            setAgents(agentList);
            
            // Auto-select first agent if none selected
            if (!selectedAgentId && agentList.length > 0 && onAgentChange) {
                onAgentChange(agentList[0].agentId);
            }
        } catch (err) {
            console.error('Error fetching agents:', err);
            setError('Failed to load agents');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className={className}>Loading agents...</div>;
    }

    if (error) {
        return <div className={className} style={{ color: 'red' }}>{error}</div>;
    }

    if (agents.length === 0) {
        return (
            <div className={className} style={{ color: 'orange' }}>
                No agents available. Please create an agent first.
            </div>
        );
    }

    return (
        <div className={className}>
            <label htmlFor="agent-select" style={{ marginRight: '10px' }}>
                <strong>Agent:</strong>
            </label>
            <select
                id="agent-select"
                value={selectedAgentId || ''}
                onChange={(e) => onAgentChange && onAgentChange(e.target.value)}
                style={{
                    padding: '5px 10px',
                    fontSize: '14px',
                    minWidth: '200px',
                }}
            >
                {agents.map(agent => (
                    <option key={agent.agentId} value={agent.agentId}>
                        {agent.name} {agent.description ? `- ${agent.description}` : ''}
                    </option>
                ))}
            </select>
            {selectedAgentId && (
                <span style={{ marginLeft: '10px', fontSize: '12px', color: '#666' }}>
                    ({agents.find(a => a.agentId === selectedAgentId)?.rag_collections?.length || 0} collections)
                </span>
            )}
        </div>
    );
}

export default AgentSelector;
